import type { DataTableColumnDef } from 'components/tables/data-table';
import { cn } from 'utils/cn';

import { ReactTable } from './BasicTable';

type Props<T extends object> = {
    columns: DataTableColumnDef<T>[];
    data: T[];
    /** Suppress the nested table's own header row. */
    skipHeader?: boolean;
    /** Surface classes. Defaults to the recessed grey the list tables use for a nested tier. */
    className?: string;
};

/**
 * The table shown inside an expanded row when its sub-rows are a plain column list — Groups'
 * member contacts, Projects' matters, Financial conditions' company details.
 *
 * Rendered through the list table's `renderExpandedContent` slot. The negative margin cancels the
 * expanded cell's 16px inset so the nested column boundaries line up with the parent row's. Its last
 * row keeps its divider, closing the nested table off against the next parent row.
 */
const SubRowTable = <T extends object>({ columns, data, skipHeader = false, className }: Props<T>) => (
    <div className="-m-4">
        <ReactTable<T>
            columns={columns}
            data={data}
            skipHeader={skipHeader}
            className={cn('bg-grey-50 [&_tr:last-child>td]:border-b', className)}
        />
    </div>
);

export default SubRowTable;
